import React from 'react';
import clone from 'clone';
import {Page} from 'react-pdf';

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import OEToolbox from '../../../lib/tools/oe-toolbox';
import retardUpdate from '../../../lib/react/update-retarder';
import {OEPDFViewScaleMode, OEPDFViewPageRenderMode, OEPDFViewProps} from './oe-pdf-view-model';

export default class OEPDFViewPage extends React.PureComponent {

    constructor(props) {
        super(props);

        this.options = clone(this.props.options);

        this.loaded = false;
        this.rendered = false;

        this.pageData = {
            size: null
        };

        this.style = {};

        this.state = {
            pageSize: clone(this.pageData.size),
            style: clone(this.style),
            prevLayoutWidth: this.props.layoutWidth
        };

        this.scrollTop = null;

        this.onRef = this.onRef.bind(this);
        this.onPageRef = this.onPageRef.bind(this);

        this.onLoadSuccess = this.onLoadSuccess.bind(this);
        this.onRenderSuccess = this.onRenderSuccess.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.pageNumber !== this.props.pageNumber)  {
            this.loaded = false;
            this.rendered = false;
            this.debugOut('PDFViewPage - page number changed - ' + String(this.props.pageNumber - 1) + ' -> ' + tring(nextProps.pageNumber - 1));
        }

        if(nextProps.layoutWidth !== this.props.layoutWidth)  {
            if(!nextProps.layoutSizeIsChanging)  this.setState({prevLayoutWidth: this.props.layoutWidth});
            this.updateStyle(nextProps);
        }

        if(nextProps.layoutSizeIsChanging !== this.props.layoutSizeIsChanging && !nextProps.layoutSizeIsChanging)  {
            this.setState({prevLayoutWidth: this.props.layoutWidth});
        }
    }

    isLoaded()  {
        return this.loaded;
    }

    isRendered()  {
        return this.rendered;
    }

    getPageData()   {
        return this.pageData;
    }

    getElementRef()    {
        return this.ref;
    }

    getPageElementRef()    {
        return this.pageRef;
    }

    updatePageData(page)    {
        let prevPageData = this.pageData;

        this.pageData = {
            size: {w: page.originalWidth, h: page.originalHeight}
        };

        if(OEToolbox.shallowEqual(prevPageData, this.pageData, true))   return;

        this.onPageDataChanged(prevPageData);
    }

    updateStyle(props)   {
        props = props || this.props;

        let style = {};

        if(props.layoutWidth && props.layoutWidth > 0 && this.pageData.size && this.pageData.size.w > 0)   {
            style.width = props.layoutWidth;
            style.height = props.layoutWidth / this.pageData.size.w * this.pageData.size.h;
        }

        if(OEToolbox.shallowEqual(style, this.style, true)) return;

        this.debugOut('PDFViewPage ' + String(this.props.pageNumber - 1) + ' - style changed - ' + 'width: ' + style.width + ', height: ' + style.height);

        this.style = style;
        this.setState({style: clone(this.style)});
    }

    onPageDataChanged(prevPageData) {
        if(this.props.onDataChanged)    this.props.onDataChanged(this, this.pageData);

        retardUpdate(this, () => {
            if(!OEToolbox.shallowEqual(prevPageData.size, this.pageData.size))   this.setState({pageSize: clone(this.pageData.size)});
            this.updateStyle();
        });
    }

    onRef(ref)  {
        this.ref = ref;
    }

    onPageRef(ref)  {
        this.pageRef = ref;
    }

    render()    {
        const layoutWidth = this.props.layoutSizeIsChanging ? this.state.prevLayoutWidth : this.props.layoutWidth;
        const scaleMode = !this.props.layoutSizeIsChanging ? this.props.scaleMode : OEPDFViewScaleMode.scale;

        return (
            <div
                className={'pdf-view-page ' + this.props.className}
                style={this.state.style}
                ref={this.onRef}
            >
                <Page
                    loading={null}
                    renderMode={this.props.visible ? this.props.renderMode : OEPDFViewPageRenderMode.none}
                    pageNumber={this.props.pageNumber}
                    width={scaleMode == OEPDFViewScaleMode.explicit ? layoutWidth : undefined}
                    scale={scaleMode == OEPDFViewScaleMode.scale && layoutWidth && this.state.pageSize && this.state.pageSize.w ? layoutWidth / this.state.pageSize.w : 1}
                    onLoadSuccess={this.onLoadSuccess}
                    onRenderSuccess={this.onRenderSuccess}
                    inputRef={this.onPageRef}
                />
            </div>
        );
    }

    onLoadSuccess(page) {
        this.loaded = true;
        this.debugOut('PDFViewPage ' + String(page.pageNumber - 1) + ' - onLoadSuccess' );
        this.updatePageData(page);
        if(this.props.onLoaded) this.props.onLoaded(this, page);
    }

    onRenderSuccess(page)   {
        this.rendered = true;
        this.updatePageData(page);
        if(this.props.onLoaded) this.props.onRendered(this, page);
    }

    debugOut(str)   {
        if(this.props.debugOutEnabled)   console.log(str);
    }
};

OEPDFViewPage.defaultProps = OEPDFViewProps.pageDefaultProps;

OEPDFViewPage.propTypes = OEPDFViewProps.pagePropTypes;